import ScheduledTasks from "./ScheduledTasks";

// Wrapper to reuse list logic from ScheduledTasks but only show the table.
const ScheduleList = () => {
  return <ScheduledTasks mode="list" />;
};

export default ScheduleList;

